// Formas de pagamento da mensalidade. Os valores são os mesmos da API
// (`customer.preferredPaymentMethod` / `monthly_charge.paymentMethod`).
// Rotulos sao getters: acompanham o idioma escolhido no Connect.
import i18n from "@/plugins/i18n";

const paymentMethod = (value, icon) => ({
  value,
  icon,
  get label() {
    return i18n.t(`enums.paymentMethod.${value}.label`);
  },
  get trait() {
    return i18n.t(`enums.paymentMethod.${value}.trait`);
  },
});

export const PAYMENT_METHODS = [
  paymentMethod("credit_card", "mdi-credit-card-outline"),
  paymentMethod("pix", "mdi-qrcode"),
  paymentMethod("boleto", "mdi-barcode"),
];

// O que falta no perfil para cada forma (código `reason` vindo da API).
// Acesso igual ao de um objeto simples: PAYMENT_METHOD_MISSING[reason].
export const PAYMENT_METHOD_MISSING = {};
["card", "cpf", "address"].forEach((reason) => {
  Object.defineProperty(PAYMENT_METHOD_MISSING, reason, {
    enumerable: true,
    get: () => i18n.t(`enums.paymentMissing.${reason}`),
  });
});

export function paymentMethodLabel(value) {
  // Cobrança zerada por desconto de Pitch Coins: baixada sem gateway.
  if (value === "pitch_coins")
    return i18n.t("enums.paymentMethod.pitch_coins.label");
  const found = PAYMENT_METHODS.find((item) => item.value === value);
  return found ? found.label : "";
}
